import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "py-2 section-app" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Form Saldo Awal Kasir ", -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-2" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Nama Kasir", -1)
const _hoisted_10 = { class: "col-lg-2" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Tanggal Transaksi", -1)
const _hoisted_13 = { class: "col-lg-2" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Sesion Kasir", -1)
const _hoisted_16 = {
  key: 0,
  class: "col-lg-2"
}
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Waroeng", -1)
const _hoisted_19 = {
  key: 1,
  class: "col-lg-2"
}
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: ""
}, "Waroeng", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "row py-3" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "" }
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-lg-3" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Total Uang", -1)
const _hoisted_31 = { class: "card-footer" }
const _hoisted_32 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Nav),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.cashierName) = $event)),
                    type: "text",
                    class: "form-control datepicker",
                    autocomplete: "off",
                    placeholder: "Nama Kasir",
                    tabindex: "1",
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, _ctx.cashierName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalDate) = $event)),
                    type: "text",
                    class: "form-control datepicker",
                    autocomplete: "off",
                    placeholder: "Nama Kasir",
                    tabindex: "1",
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, _ctx.modalDate]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cashierSesi) = $event)),
                    type: "text",
                    class: "form-control datepicker",
                    autocomplete: "off",
                    placeholder: "Nama Kasir",
                    tabindex: "1",
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, _ctx.cashierSesi]
                  ])
                ])
              ]),
              (_ctx.modalId != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.waroengNama) = $event)),
                        type: "text",
                        class: "form-control datepicker",
                        autocomplete: "off",
                        tabindex: "1",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, _ctx.waroengNama]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.modalId == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _withDirectives(_createElementVNode("select", {
                        class: "form-control option",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.waroengId) = $event)),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateTmpUser()))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.waroengList, (item, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: 'waroeng' + index,
                            value: item.m_w_id
                          }, _toDisplayString(item.m_w_nama), 9, _hoisted_22))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.waroengId]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pecahan, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-lg",
                  key: 'tipe-urut' + item.value
                }, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("label", _hoisted_25, _toDisplayString(item.name), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control number",
                      "onUpdate:modelValue": ($event: any) => ((item.qty) = $event),
                      min: "0"
                    }, null, 8, _hoisted_26), [
                      [_vModelText, item.qty]
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control option",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.totalUangModal) = $event)),
                    readonly: ""
                  }, null, 512), [
                    [_vModelText, _ctx.totalUangModal]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("button", {
              disabled: _ctx.totalUangModal == 0 || _ctx.saveDisable,
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.submitTxt), 9, _hoisted_32)
          ])
        ])
      ])
    ])
  ]))
}